export default function Folder2Icon() {
  return (
    <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M54.139 15.355H30.576l-7.678-7.704s-.216-.151-.36-.151H5.862c-1.176 0-2.112.979-2.112 2.209v40.607c0 1.205.936 2.184 2.112 2.184h48.276c1.152 0 2.088-.979 2.112-2.184V17.54c0-1.205-.936-2.184-2.111-2.184zm-33.305-2.91 2.903 2.91H8.477v-2.91h12.357zM51.5 47.58H8.477V20.3h43.046v27.28H51.5z" fill="#333"/>
    </svg>
  );
}
